import {
  Component,
  Input,
  OnInit,
  EventEmitter,
  Output,
  ViewChildren,
  QueryList,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  AircraftRelationSkeleton,
  AircraftRelationAudit,
  PhoneNumberAudit,
  EmailAddressAudit,
  AddressAudit
} from '../../+models/aircraft-profile-audit.model';
import { PhoneNumberAuditListComponent } from '../phone-number-audit-list/phone-number-audit-list.component';
import { EmailAddressAuditListComponent } from '../email-address-audit-list/email-address-audit-list.component';
import { AddressAuditListComponent } from '../address-audit-list/address-audit-list.component';

@Component({
  selector: 'sd-portal-aircraft-relation-audit-list',
  templateUrl: './aircraft-relation-audit-list.component.html',
  styleUrls: ['./aircraft-relation-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AircraftRelationAuditListComponent implements OnInit {
  @ViewChildren('phoneNumberAuditList')
  phoneNumberAuditLists: QueryList<PhoneNumberAuditListComponent>;
  @ViewChildren('faxNumberAuditList') faxNumberAuditLists: QueryList<PhoneNumberAuditListComponent>;
  @ViewChildren(EmailAddressAuditListComponent)
  emailAddressAuditLists: QueryList<EmailAddressAuditListComponent>;
  @ViewChildren(AddressAuditListComponent) addressAuditLists: QueryList<AddressAuditListComponent>;

  @Input() aircraftRelation: AircraftRelationSkeleton;
  @Input() loading: boolean;
  @Input() aircraftRelationAudits: AircraftRelationAudit[];

  @Input() phoneNumberAudits: PhoneNumberAudit[];
  @Input() phoneNumberAuditsLoading: boolean;

  @Input() faxNumberAudits: PhoneNumberAudit[];
  @Input() faxNumberAuditsLoading: boolean;

  @Input() emailAddressAudits: EmailAddressAudit[];
  @Input() emailAddressAuditsLoading: boolean;

  @Input() addressAudits: AddressAudit[];
  @Input() addressAuditsLoading: boolean;

  @Output() loadAircraftRelation = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  @Output() loadPhoneNumber = new EventEmitter<number>();
  @Output() nextPhoneNumberPage = new EventEmitter<number>();

  @Output() loadFaxNumber = new EventEmitter<number>();
  @Output() nextFaxNumberPage = new EventEmitter<number>();

  @Output() loadEmailAddress = new EventEmitter<number>();
  @Output() nextEmailAddressPage = new EventEmitter<number>();

  @Output() loadAddress = new EventEmitter<number>();
  @Output() nextAddressPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadAircraftRelation.emit(this.aircraftRelation.aircraftRelationId);
  }

  phoneNumberOpened(phoneNumberId: number) {
    setTimeout(() => {
      const match = this.phoneNumberAuditLists.find(c => c.phoneNumberId === phoneNumberId);
      if (!match) {
        return;
      }
      match.loadData();
    });
  }

  faxNumberOpened(faxNumberId: number) {
    setTimeout(() => {
      const match = this.faxNumberAuditLists.find(c => c.phoneNumberId === faxNumberId);
      if (!match) {
        return;
      }
      match.loadData();
    });
  }

  emailAddressOpened(emailAddressId: number) {
    setTimeout(() => {
      const match = this.emailAddressAuditLists.find(c => c.emailAddressId === emailAddressId);
      if (!match) {
        return;
      }
      match.loadData();
    });
  }

  addressOpened(addressId: number) {
    setTimeout(() => {
      const match = this.addressAuditLists.find(c => c.addressId === addressId);
      if (!match) {
        return;
      }
      match.loadData();
    });
  }

  onNextPage() {
    this.nextPage.emit(this.aircraftRelation.aircraftRelationId);
  }
}
